// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"11dad226","51":"2ab22a54","137":"cf220060","458":"8f95ae27","693":"60f0efb0","738":"f15b95fa","909":"055689ba"}[chunkId] + ".chunk.js";
};